import { render, staticRenderFns } from "./ToggleThemesButton.vue?vue&type=template&id=36cbe6d4&scoped=true&"
import script from "./ToggleThemesButton.vue?vue&type=script&lang=ts&"
export * from "./ToggleThemesButton.vue?vue&type=script&lang=ts&"
import style0 from "./ToggleThemesButton.vue?vue&type=style&index=0&id=36cbe6d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cbe6d4",
  null
  
)

export default component.exports